var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { debugLog } from "./debugLog";
import { getGameRefParameter, getLobbyIdParameter, getParameter } from "./getParameter";
export const fetchLauncherConfig = (pathConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const fallback = { fullname: "-", studio: "-" };
    return new Promise((resolve) => {
        var _a, _b, _c;
        const gameId = encodeURIComponent((_b = (_a = getGameRefParameter()) !== null && _a !== void 0 ? _a : getLobbyIdParameter()) !== null && _b !== void 0 ? _b : "");
        const jurisdiction = encodeURIComponent((_c = getParameter("jurisdiction")) !== null && _c !== void 0 ? _c : "");
        if (gameId === "") {
            debugLog("Game name fetch failed: No game id");
            resolve(fallback);
            return;
        }
        fetch(`${pathConfig.launcherconfigurl}?gameref=${gameId}&jurisdiction=${jurisdiction}`).then((response) => {
            const STATUS_OK = 200;
            if (response.status !== STATUS_OK) {
                debugLog(`Unable to fetch game name: ${response.status}`);
                resolve(fallback);
            }
            else {
                response.json().then((payload) => {
                    var _a;
                    if (payload.fullname !== null) {
                        document.title = (_a = payload.displayfullname) !== null && _a !== void 0 ? _a : payload.fullname;
                        resolve(payload);
                    }
                    else {
                        resolve(fallback);
                    }
                }).catch((reason) => {
                    debugLog(`Unable to parse getlauncherconfig JSON: ${JSON.stringify(reason)}`);
                    resolve(fallback);
                });
            }
        }).catch((reason) => {
            debugLog(`Game name fetch failed: ${JSON.stringify(reason)}`);
            resolve(fallback);
        });
    });
});
